// extracted by mini-css-extract-plugin
export default {"container":"_1mwg6y-k","desktopFrame":"K48YsZtk","mobileFrame":"_2MxaLBJ_","lazyFill":"_3N7jVSDc","image":"brui4K1H"};